import styled from 'styled-components';
// import { COLORS } from "../../constants/constants";
//background: linear-gradient(to bottom right,rgb(0, 191, 255), #00ffff, #4169e1);

export const DashboardContainer = styled.div`
    background: linear-gradient(to bottom right,rgb(229, 248, 255),rgb(223, 255, 255),rgb(144, 172, 255));
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

export const DashboardSubContainer = styled.div`
    margin: 0 20px;
`

export const DashboardContent = styled.aside.withConfig({
    shouldForwardProp: (prop) => prop !== 'sidebar'
  })`
    // width: ${({ sidebar }) => (sidebar ? '88.56%' : '95.85%')};
    height: 100%;
    margin-left: ${({ sidebar }) => (sidebar ? '220px' : '80px')};
    margin-top: 50px;
    transition: 0.3s all ease-in-out;

    @media screen and (max-width: 768px) {
        margin-left: 0px;
        // width: 100%;
        transition: 0.3s all ease-in-out;
    }
`
